import { render, staticRenderFns } from "./BackInHistoryBtn.vue?vue&type=template&id=2f5ba638&scoped=true&"
import script from "./BackInHistoryBtn.vue?vue&type=script&lang=js&"
export * from "./BackInHistoryBtn.vue?vue&type=script&lang=js&"
import style0 from "./BackInHistoryBtn.vue?vue&type=style&index=0&id=2f5ba638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ba638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5ba638')) {
      api.createRecord('2f5ba638', component.options)
    } else {
      api.reload('2f5ba638', component.options)
    }
    module.hot.accept("./BackInHistoryBtn.vue?vue&type=template&id=2f5ba638&scoped=true&", function () {
      api.rerender('2f5ba638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BackInHistoryBtn.vue"
export default component.exports